import React from "react";

import { LoadList } from "../../types/List";
import { useNewBrandStyle } from "../hooks/useNewBrandStyle";
const assetPrefix = process.env.ASSET_PREFIX || "";

interface RefreshListProps {
  action: LoadList;
}

export default function RefreshList({ action }: RefreshListProps) {
  const isNewBrandEnabled = useNewBrandStyle();

  const refreshIconPath = isNewBrandEnabled
    ? "new-brand/refresh-list-icon.svg"
    : "refresh-icon.svg";
  return (
    <button
      data-type="tertiary"
      type="button"
      onClick={() => action()}
      data-testid="refresh"
    >
      <img
        src={`${assetPrefix}/static/${refreshIconPath}`}
        alt="Refresh list"
      />
    </button>
  );
}
